@if (isChatOpenedOrMinimized()) {
    <ap-floating-action-button
        title="{{ 'conversational.chat.container.title' | apContent }}"
        [badgeNumber]="unreadMessageCount()"
        [open]="isChatOpen()"
        (openedOrClosed)="changeChatVisibility($event)"
    >
        <ng-content></ng-content>
    </ap-floating-action-button>
}
